import { httpClient } from '@/app/libs/axios';

interface AccessTokenResponse {
  expiresIn: number;
  accessToken: string;
  refreshToken: string;
  refreshExpiresIn: number;
  idToken: string;
  tokenType: string;
  scope: string;
  sessionState: string;
}

export async function getAccessToken({ code, requestUri }: { code: string; requestUri: string }) {
  return httpClient.get<AccessTokenResponse>('/accesstoken', {
    params: { code, requestUri },
    safeErrorStatus: [401],
  });
}
